export default __webpack_public_path__ + "073cf1f59aeea5337b15804789e649cc.png";